export const api_base_url = process.env.REACT_APP_API_BASE_URL;
export const cdn_url = process.env.REACT_APP_CDN_URL;
export const app_directory = process.env.REACT_APP_APP_DIRECTORY;
export const app_name = process.env.REACT_APP_APP_NAME;
export const app_description = process.env.REACT_APP_APP_DESCRIPTION;
export const app_email = process.env.REACT_APP_APP_EMAIL;
